import React from "react";
import { Inbox } from "lucide-react";

export function EmptyState({ icon: Icon = Inbox, title, description, action, testId }) {
  return (
    <div
      data-testid={testId || "empty-state"}
      className="flex flex-col items-center justify-center text-center border border-dashed border-border rounded-lg py-16 px-6 bg-card"
    >
      <Icon className="w-10 h-10 text-muted-foreground/40 mb-3" strokeWidth={1.5} />
      <h3 className="text-sm font-semibold">{title}</h3>
      {description && (
        <p className="text-xs text-muted-foreground mt-1 max-w-sm">{description}</p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
